import { Resolvers } from '../apollo/operations';

export const resolvers: Resolvers = {
  // @ts-ignore
  Query: {},
};
